/**
 * Who may open which part of the admin area (ZLAYT-1241).
 *
 * The admin area used to rely on hiding tabs, so anyone who typed an /admin
 * address could open any page in it. The routes now enforce these rules and
 * the tab strip and sidebar read the same ones.
 *
 * A super admin sees everything. A firm account (`is_company`) has had the
 * sidebar link since ZLAYT-738 and keeps the tabs that only show its own
 * firm's data, which the server already scopes to the caller. Everyone else
 * is sent home.
 */

interface AdminAreaUser {
  is_superuser?: boolean;
  is_company?: boolean;
}

/** Admin tabs a firm account may open, in the order the tab strip shows them. */
export const FIRM_ACCOUNT_ADMIN_TABS = [
  'document-prompt-preview',
  'token-usage',
  'credit-usage',
] as const;

export const SUPER_ADMIN_LANDING = '/admin/multi-document-agent';
export const FIRM_ACCOUNT_LANDING = `/admin/${FIRM_ACCOUNT_ADMIN_TABS[0]}`;

export const isSuperAdmin = (user?: AdminAreaUser | null) =>
  Boolean(user?.is_superuser);

export const canOpenAdminArea = (user?: AdminAreaUser | null) =>
  Boolean(user?.is_superuser || user?.is_company);

export const adminLandingPath = (user?: AdminAreaUser | null) =>
  isSuperAdmin(user) ? SUPER_ADMIN_LANDING : FIRM_ACCOUNT_LANDING;

export const canOpenAdminTab = (
  user: AdminAreaUser | null | undefined,
  tab: string
) =>
  isSuperAdmin(user) ||
  (canOpenAdminArea(user) &&
    (FIRM_ACCOUNT_ADMIN_TABS as readonly string[]).includes(tab));
